import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import type { BackButtonProps } from '@fourthwall/components'
import { BackButton } from '@fourthwall/components'

type Props = BackButtonProps

export const DashboardBackButton = (props: Props) => {
  const location = useLocation()
  const navigate = useNavigate()

  const shouldUseBrowserBack = () => {
    const from = location.state?.from?.location
    const to = props.to

    if (!from || !to) return false

    const fromUrl = `${from.pathname}${from.search}`
    const targetUrl =
      typeof to === 'string' ? to : `${to.pathname ?? ''}${to.search ? `?${to.search}` : ''}`

    return fromUrl === targetUrl
  }

  if (shouldUseBrowserBack()) {
    return <BackButton {...props} onClick={() => navigate(-1)} />
  }

  if (location.state?.from) {
    return (
      <BackButton
        {...props}
        label={location.state.from.label}
        to={{
          pathname: location.state.from.location.pathname,
          search: location.state.from.location.search,
        }}
        state={location.state.from.state}
      />
    )
  }

  return <BackButton {...props} />
}
